import { Button } from '@/components/ui/Button';
import { cn } from '@/lib/cn';

type ListPaginationProps = {
  page: number;
  lastPage: number;
  summary?: string;
  onPageChange: (page: number) => void;
  className?: string;
};

export function ListPagination({
  page,
  lastPage,
  summary,
  onPageChange,
  className,
}: ListPaginationProps) {
  if (lastPage <= 1 && !summary) return null;

  return (
    <div
      className={cn(
        'flex flex-wrap items-center justify-between gap-3 border-t border-manejai-sand/60 px-5 py-3 text-sm',
        className,
      )}
    >
      {summary && (
        <span className="text-xs text-manejai-bark/50">
          {summary}
          {lastPage > 1 && <> · Página {page} de {lastPage}</>}
        </span>
      )}
      {lastPage > 1 && (
        <div className="ml-auto flex gap-2">
          <Button
            type="button"
            variant="outline"
            size="sm"
            disabled={page <= 1}
            onClick={() => onPageChange(page - 1)}
          >
            Anterior
          </Button>
          <Button
            type="button"
            variant="outline"
            size="sm"
            disabled={page >= lastPage}
            onClick={() => onPageChange(page + 1)}
          >
            Próxima
          </Button>
        </div>
      )}
    </div>
  );
}
